// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pervasives from "../../../../rescript/lib/es6/pervasives.js";

function getDefaultErrorEntity(message, titleOpt, param) {
  var title = titleOpt !== undefined ? titleOpt : ({
        TAG: /* Custom */0,
        _0: "Default Error"
      });
  return /* DefaultError */{
          _0: {
            title: title,
            message: message
          }
        };
}

function resolveError(error) {
  return error._0.message;
}

function raiseError(path, message, valueOpt) {
  var value = valueOpt !== undefined ? valueOpt : "";
  return Pervasives.failwith(path + (" : " + (message + (" - " + value))));
}

export {
  getDefaultErrorEntity ,
  resolveError ,
  raiseError ,
  
}
/* No side effect */
